import { Price } from '@webapp/core/components/Price'
import { useProcurifyIntl } from '@webapp/hooks'
import { type CurrencyName } from '@webapp/models/enums'
import { BillItemPopoverLayout } from './BillItemPopoverLayout'
import messages from './messages'

interface BillItemTaxAmountPopoverContentProps {
  calculatedTaxAmount: number
  currencyName: CurrencyName
}

export const BillItemTaxAmountPopoverContent = ({
  calculatedTaxAmount,
  currencyName,
}: BillItemTaxAmountPopoverContentProps) => {
  const intl = useProcurifyIntl()

  return (
    <BillItemPopoverLayout
      title={intl.formatMessage(messages.taxAmountEditedTitle)}
      bodyRows={[
        {
          id: 'system-calculated-tax',
          label: intl.formatMessage(messages.systemCalculatedTaxLabel),
          valueComponent: (
            <Price
              price={calculatedTaxAmount}
              currency={currencyName}
              fontWeight='normal'
            />
          ),
        },
      ]}
    />
  )
}

BillItemTaxAmountPopoverContent.displayName = 'BillItemTaxAmountPopoverContent'
